import React from 'react';
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface NoticeDialogProps {
	isOpen: boolean;
	onClose: () => void;
	noticeTitle: string;
	noticeText: string;
}

const NoticeDialog: React.FC<NoticeDialogProps> = ({
	isOpen,
	onClose,
	noticeTitle,
	noticeText,
}) => {
	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{noticeTitle}</DialogTitle>
					<DialogDescription>{noticeText}</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button
						onClick={onClose}
						className='bg-[#FBB040] text-primary-foreground hover:bg-primary/90 focus:ring-primary/50'
					>
						Close
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default NoticeDialog;
